// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2l8vJ","title":"Images90_title__2js8R","images":"Images90_images__3ZQM8"};